import React from 'react';
import { Col, Row } from 'react-flexbox-grid';

export const ExistePagoEfectivo = ({CIPObtenido, fechaObtenida, mostrarCIP}) => {
  return (
    <>
    {
      mostrarCIP &&
      <Row center="xs">
        <Col xs={12} sm={5}>      
            <h4>
              Ya existe un CIP generado {CIPObtenido}
            </h4>
            <h4>Fecha Vencimiento: {fechaObtenida}</h4>
        </Col>
      </Row>
    }
    </>
  )
}
